const default_position = {
  top: "0",
  left: "0",
  height: "0",
  width: "0",
}
const state = {
  renderTools: undefined,
  floatFrameHover: {
    id: '',
    name: '',
    position: default_position
  },
  floatFrameActive: {
    id: '',
    name: '',
    position: default_position
  },
  sectionHover: {
    id: '',
    name: '',
    position: default_position
  },
  sectionActive: {
    id: '',
    name: '',
    position: default_position
  },
  cellHover: {
    id: '',
    position: default_position
  },
  cellActive: {
    id: '',
    position: default_position
  },
  gridHover: {
    id: '',
    position: default_position
  },
  gridActive: {
    id: '',
    position: default_position
  },
  widgetHover: {
    id: '',
    position: default_position
  },
  widgetActive: {
    id: '',
    position: default_position,
    theme: null, // null=normal, blue-dark
    toolbarEnable: true,
    resizeDotEnable: true,
  },
  parentWidgetActive: {
    id: '',
    position: default_position
  },
  slideItemActive: {
    widgetId: '',
    index: 0,
  },
  slideBlockHover: {
    id: '',
    position: default_position,
    index: 0,
    parent_id: '',
  },
  slideBlockActive: {
    id: '',
    position: default_position,
    index: 0,
    parent_id: '',
  },
  resizeMarginHover: {
    id: '',
    position: default_position,
    type: '',
    parent_id: '',
    direction: 'top',
    is_last: false,
    is_show_margin_setting: true,
    label_add_btn: '',
    other_id: '',
    height: null,
    is_first: false,
    is_show_add_btn: true
  },
  slideSectionHover: {
    id: '',
    position: default_position,
    index: 0
  },
  slideSectionActive: {
    id: '',
    position: default_position,
    index: 0
  },
  slideContainerHover: {
    id: '',
    position: default_position,
  },
  slideContainerActive: {
    id: '',
    position: default_position,
  },
  addBtnActive: {
    id: '',
    position: default_position,
    type: '',
    parent_id: '',
    direction: 'top',
    label_add_btn: '',
    height: null,
  },
  disableDragWidgetId: undefined, 
}

const getters = {
  renderTools: () => {
    return state.renderTools;
  },
  
  floatFrameHover: state => {
    return state.floatFrameHover
  },
  floatFrameActive: state => {
    return state.floatFrameActive
  },

  sectionHover: state => {
    return state.sectionHover
  },
  sectionActive: state => {
    return state.sectionActive
  },

  slideSectionHover: state => {
    return state.slideSectionHover
  },
  slideSectionActive: state => {
    return state.slideSectionActive
  },
  slideContainerHover: state => {
    return state.slideContainerHover
  },
  slideContainerActive: state => {
    return state.slideContainerActive
  },

  cellHover: state => {
    return state.cellHover
  },
  cellActive: state => {
    return state.cellActive
  },

  gridHover: state => {
    return state.gridHover
  },

  gridActive: state => {
    return state.gridActive
  },
  widgetHover: state => {
    return state.widgetHover
  },

  widgetActive: state => {
    return state.widgetActive
  },
  parentWidgetActive: state => {
    return state.parentWidgetActive
  },
  slideItemActive: state => {
    return state.slideItemActive
  },
  slideBlockHover: state => {
    return state.slideBlockHover
  },
  slideBlockActive: state => {
    return state.slideBlockActive
  },
  resizeMarginHover: state => {
    return state.resizeMarginHover
  },
  addBtnActive: state => {
    return state.addBtnActive
  },
  disableDragWidgetId: state => {
    return state.disableDragWidgetId
  },
}
const actions = {
  init: async ({ dispatch }, { renderTools }) => {
    await dispatch('setRenderTools', { renderTools: renderTools })
  },

  setRenderTools({ commit }, { renderTools }) {
    commit('SET_RENDER_TOOLS', { renderTools: renderTools });
  },

  setFloatFrameHover({ commit, dispatch }, { component_id, name }) {
    dispatch('designIframe/component/setOverlayAction', { component_id, type: 'FLOATFRAME', action: 'HOVER' }, { root: true })
    commit('SET_FLOATFRAME_HOVER', { component_id, name })
  },
  setFloatFrameActive({ commit, dispatch }, { component_id, name }) {
    dispatch('designIframe/component/setOverlayAction', { component_id, type: 'FLOATFRAME', action: 'ACTIVE' }, { root: true })
    commit('SET_FLOATFRAME_ACTIVE', { component_id, name })
  },

  setSectionHover({ commit, dispatch }, { component_id, name }) {
    dispatch('designIframe/component/setComponentAction', { component_id, type: 'SECTION', action: 'HOVER' }, { root: true })
    commit('SET_SECTION_HOVER', { component_id, name })
  },
  setSectionActive({ commit, dispatch }, { component_id, name }) {
    dispatch('designIframe/component/setComponentAction', { component_id, type: 'SECTION', action: 'ACTIVE' }, { root: true })
    commit('SET_SECTION_ACTIVE', { component_id, name })
  },
  setSlideSectionHover({ commit, dispatch }, { component_id, index }) {
    dispatch('designIframe/component/setComponentAction', { component_id, type: 'SLIDE_SECTION', action: 'HOVER' }, { root: true })
    commit('SET_SLIDE_SECTION_HOVER', { component_id, index })
  },
  setSlideSectionActive({ commit, dispatch }, { component_id, index }) {
    dispatch('designIframe/component/setComponentAction', { component_id, type: 'SLIDE_SECTION', action: 'ACTIVE' }, { root: true })
    commit('SET_SLIDE_SECTION_ACTIVE', { component_id, index })
  },
  setSlideContainerHover({ commit, dispatch }, { component_id }) {
    dispatch('designIframe/component/setComponentAction', { component_id, type: 'SLIDE_CONTAINER', action: 'HOVER' }, { root: true })
    commit('SET_SLIDE_CONTAINER_HOVER', { component_id })
  },
  setSlideContainerActive({ commit, dispatch }, { component_id }) {
    dispatch('designIframe/component/setComponentAction', { component_id, type: 'SLIDE_CONTAINER', action: 'ACTIVE' }, { root: true })
    commit('SET_SLIDE_CONTAINER_ACTIVE', { component_id })
  },
  setCellHover({ commit, dispatch }, { component_id, parent_id }) {
    dispatch('designIframe/component/setComponentAction', { component_id, type: 'CELL', action: 'HOVER' }, { root: true })
    dispatch('designIframe/component/setComponentAction', { component_id: parent_id, type: 'GRID', action: 'HOVER' }, { root: true })
    commit('SET_CELL_HOVER', { component_id })
    commit('SET_GRID_HOVER', { component_id: parent_id })
  },
  setCellActive({ commit, dispatch }, { component_id, parent_id, widget_key }) {
    if (component_id) {
      dispatch('designIframe/component/setComponentActivePosition', { component_id, type: 'CELL', action: 'ACTIVE' }, { root: true })
    }
    dispatch('designIframe/component/setComponentAction', { component_id: widget_key, type: 'WIDGET', action: 'ACTIVE' }, { root: true })
    dispatch('designIframe/component/setComponentAction', { component_id, type: 'CELL', action: 'ACTIVE' }, { root: true })
    dispatch('designIframe/component/setComponentAction', { component_id: parent_id, type: 'GRID', action: 'ACTIVE' }, { root: true })
    commit('SET_WIDGET_ACTIVE', { component_id: widget_key })
    commit('SET_CELL_ACTIVE', { component_id })
    commit('SET_GRID_ACTIVE', { component_id: parent_id })
  },
  setWidgetHover({ commit, dispatch }, { component_id }) {
    dispatch('designIframe/component/setComponentAction', { component_id, type: 'WIDGET', action: 'HOVER' }, { root: true })
    // commit('SET_CELL_HOVER', { component_id: undefined })
    // commit('SET_GRID_HOVER', { component_id: undefined })
    commit('SET_WIDGET_HOVER', { component_id })
  },
  setWidgetHoverPosition({ commit }, { position }) {
    commit('SET_WIDGET_HOVER_POSITION', { position })
  },
  setWidgetActive({ dispatch }, { grid_id, cell_id, component_id }) {

    // dispatch('designIframe/component/setComponentAction', { component_id, type: 'WIDGET', action: 'ACTIVE' }, {root: true})
    // commit('SET_WIDGET_ACTIVE', { component_id })
    dispatch('designIframe/frame/setCellActive', { component_id: cell_id, parent_id: grid_id, widget_key: component_id }, { root: true })
  },
  setWidgetActivePosition({ commit }, { position }) {
    commit('SET_WIDGET_ACTIVE_POSITION', { position })
  },
  setWidgetActiveTheme({ commit }, { theme }) {
    commit('SET_WIDGET_ACTIVE_THEME', { theme: theme })
  },
  setWidgetActiveToolbarEnable({ commit }, { enable }) {
    commit('SET_WIDGET_ACTIVE_TOOLBAR_ENABLE', { enable: enable })
  },
  setWidgetActiveResizeDotEnable({ commit }, { enable }) {
    commit('SET_WIDGET_ACTIVE_RESIZEDOT_ENABLE', { enable: enable })
  },
  setSlideBlockHover({ commit, dispatch }, { component_id, index, parent_id }) {
    dispatch('designIframe/component/setComponentAction', { component_id: `${component_id}`, type: 'SLIDEBLOCK', action: 'HOVER' }, { root: true })
    // dispatch('designIframe/component/setComponentAction', { component_id: parent_id, type: 'WIDGET', action: 'HOVER' })
    commit('SET_SLIDEBLOCK_HOVER', { component_id, index, parent_id })
    // commit('SET_WIDGET_HOVER', { component_id: parent_id })
  },
  setSlideBlockActive({ commit, dispatch }, { component_id, parent_id, index }) {
    dispatch('designIframe/component/setComponentAction', { component_id: `${component_id}`, type: 'SLIDEBLOCK', action: 'ACTIVE' }, { root: true })
    dispatch('designIframe/component/setComponentAction', { component_id: parent_id, type: 'WIDGET', action: 'ACTIVE' }, { root: true })

    commit('SET_SLIDEBLOCK_ACTIVE', { component_id, index, parent_id })
    commit('SET_WIDGET_ACTIVE', { component_id: parent_id })
  },
  setSiteWidgetHover({ commit, dispatch }, { component_id }) {
    dispatch('designIframe/component/setComponentAction', { component_id: component_id, type: 'WIDGET', action: 'HOVER' }, { root: true })
    commit('SET_WIDGET_HOVER', { component_id: component_id })
  },
  setSiteWidgetActive({ commit, dispatch }, { component_id }) {
    dispatch('designIframe/component/setComponentAction', { component_id: component_id, type: 'WIDGET', action: 'ACTIVE' }, { root: true })
    commit('SET_WIDGET_ACTIVE', {component_id: component_id })
  },
  setParentWidgetActive({ commit, dispatch }, { component_id,parent_id }) {
    // set parent of widget 
    dispatch('designIframe/component/setComponentAction', { component_id: parent_id, type: 'PARENT_WIDGET', action: 'ACTIVE' }, { root: true })
    commit('SET_PARENT_WIDGET_ACTIVE', { component_id: parent_id })
    // set widget
    dispatch('designIframe/component/setComponentAction', { component_id: component_id, type: 'WIDGET', action: 'ACTIVE' }, { root: true })
    commit('SET_WIDGET_ACTIVE', { component_id: component_id })

  },
  setSlideWidgetActive({ commit, dispatch }, { component_id, slide_section_id, index }) {
    dispatch("setSlideSectionActive", {
      component_id: slide_section_id,
      index: index,
    });
    // dispatch("setSlideContainerActive", {
    //   component_id: slide_container_id,
    // });
    dispatch('designIframe/component/setComponentAction', { component_id: component_id, type: 'WIDGET', action: 'ACTIVE' }, { root: true })
    commit('SET_WIDGET_ACTIVE', { component_id: component_id })
  },
  setComponentAction({ commit }, { component_id, type, action }) {
    const element = document.getElementById(`comp-${component_id}`)
    if (element) {
      const rect = element.getBoundingClientRect()
      const position = {
        top: (rect.top + document.documentElement.scrollTop) + "px",
        height: rect.height + "px",
        left: rect.left + "px",
        width: rect.width + "px",
      }
      commit(`SET_${type}_${action}_POSITION`, { position })
    } else {
      commit(`SET_${type}_${action}_POSITION`, {
        position: {
          top: 0,
          height: 0,
          left: 0,
          width: 0,
        }
      })
    }
  },
  setSlideItemActive({ commit }, { widgetId, index }) {
    commit('SET_SLIDE_ITEM_ACTIVE', { widgetId, index })
  },
  setResizeMarginHover({ dispatch, commit }, { type, component_id, parent_id, direction, label_add_btn, is_last, other_id, height, is_first, is_show_add_btn = true }) {
    dispatch('designIframe/component/setResizeMarginAction', { component_id, direction }, { root: true })

    commit('SET_RESIZE_MARGIN_HOVER', { type, component_id, parent_id, direction, label_add_btn, is_last, other_id, height, is_first, is_show_add_btn })
  },
  setAddBtnActive({ dispatch, commit }, { type, component_id, parent_id, direction, label_add_btn }) {
    dispatch('designIframe/component/setAddBtnAction', { component_id, direction }, { root: true })

    commit('SET_ADD_BTN_ACTIVE', { type, component_id, parent_id, direction, label_add_btn })
  },
  reRenderFrame({ dispatch, state }) {
    dispatch('designIframe/component/setComponentAction', { component_id: state.widgetHover.id, type: 'WIDGET', action: 'HOVER' }, { root: true })
    dispatch('designIframe/component/setComponentAction', { component_id: state.widgetActive.id, type: 'WIDGET', action: 'ACTIVE' }, { root: true })
    dispatch('designIframe/component/setComponentAction', { component_id: state.parentWidgetActive.id, type: 'PARENT_WIDGET', action: 'ACTIVE' }, { root: true })
    dispatch('designIframe/component/setComponentAction', { component_id: state.sectionHover.id, type: 'SECTION', action: 'HOVER' }, { root: true })
    dispatch('designIframe/component/setComponentAction', { component_id: state.sectionActive.id, type: 'SECTION', action: 'ACTIVE' }, { root: true })
    dispatch('designIframe/component/setComponentAction', { component_id: state.slideSectionHover.id, type: 'SLIDE_SECTION', action: 'HOVER' }, { root: true })
    dispatch('designIframe/component/setComponentAction', { component_id: state.slideSectionActive.id, type: 'SLIDE_SECTION', action: 'ACTIVE' }, { root: true })
    dispatch('designIframe/component/setComponentAction', { component_id: state.slideContainerHover.id, type: 'SLIDE_CONTAINER', action: 'HOVER' }, { root: true })
    dispatch('designIframe/component/setComponentAction', { component_id: state.slideContainerActive.id, type: 'SLIDE_CONTAINER', action: 'ACTIVE' }, { root: true })
    dispatch('designIframe/component/setComponentAction', { component_id: state.cellHover.id, type: 'CELL', action: 'HOVER' }, { root: true })
    dispatch('designIframe/component/setComponentAction', { component_id: state.cellActive.id, type: 'CELL', action: 'ACTIVE' }, { root: true })
    dispatch('designIframe/component/setComponentAction', { component_id: state.gridHover.id, type: 'GRID', action: 'HOVER' }, { root: true })
    dispatch('designIframe/component/setComponentAction', { component_id: state.gridActive.id, type: 'GRID', action: 'ACTIVE' }, { root: true })
    dispatch('designIframe/component/setComponentAction', { component_id: state.slideBlockHover.id, type: 'SLIDEBLOCK', action: 'HOVER' }, { root: true })
    dispatch('designIframe/component/setComponentAction', { component_id: state.slideBlockActive.id, type: 'SLIDEBLOCK', action: 'ACTIVE' }, { root: true })
    dispatch('designIframe/component/setOverlayAction', { component_id: state.floatFrameHover.id, type: 'FLOATFRAME', action: 'HOVER' }, { root: true })
    dispatch('designIframe/component/setOverlayAction', { component_id: state.floatFrameActive.id, type: 'FLOATFRAME', action: 'ACTIVE' }, { root: true })

  },
  resetFrame({ dispatch }) {
    dispatch("setCellActive", {});
    dispatch("setCellHover", {});
    dispatch("setWidgetActive", {});
    dispatch("setParentWidgetActive", {});
    dispatch("setWidgetHover", {});
    dispatch("setSectionActive", {});
    dispatch("setSectionHover", {});
    dispatch("setSlideSectionActive", {});
    dispatch("setSlideSectionHover", {});
    dispatch("setSlideContainerActive", {});
    dispatch("setSlideContainerHover", {});
    dispatch("setFloatFrameActive", {});
    dispatch("setFloatFrameHover", {});
    dispatch("setResizeMarginHover", {});
    dispatch("setAddBtnActive", {});
    dispatch("setSiteWidgetHover", {});
    dispatch("setSiteWidgetActive", {});
  },
  setDisableDragWidgetId({ commit }, { widgetId }) {
    commit('SET_DISABLE_DRAG_WIDGET_ID', { widgetId })
  },
}
const mutations = {
  SET_RENDER_TOOLS(state, { renderTools }) {
    state.renderTools = renderTools;
  },

  SET_FLOATFRAME_HOVER(state, { component_id, name }) {
    state.floatFrameHover.id = component_id
    state.floatFrameHover.name = name
  },
  SET_FLOATFRAME_HOVER_POSITION(state, { position }) {
    state.floatFrameHover.position = position
  },
  SET_FLOATFRAME_ACTIVE(state, { component_id, name }) {
    state.floatFrameActive.id = component_id
    state.floatFrameActive.name = name
  },
  SET_FLOATFRAME_ACTIVE_POSITION(state, { position }) {
    state.floatFrameActive.position = position
  },

  SET_SECTION_HOVER(state, { component_id, name }) {
    state.sectionHover.id = component_id
    state.sectionHover.name = name
  },
  SET_SECTION_HOVER_POSITION(state, { position }) {
    state.sectionHover.position = position
  },
  SET_SECTION_ACTIVE_POSITION(state, { position }) {
    state.sectionActive.position = position
  },
  SET_SECTION_ACTIVE(state, { component_id, name }) {
    state.sectionActive.id = component_id
    state.sectionActive.name = name
  },
  
  SET_SLIDE_SECTION_HOVER(state, { component_id, index}) {
    state.slideSectionHover.id = component_id,
    state.slideSectionHover.index = index
  },
  SET_SLIDE_SECTION_HOVER_POSITION(state, { position }) {
    state.slideSectionHover.position = position
  },
  SET_SLIDE_SECTION_ACTIVE(state, { component_id, index}) {
    state.slideSectionActive.id = component_id,
    state.slideSectionActive.index = index
  },
  SET_SLIDE_SECTION_ACTIVE_POSITION(state, { position }) {
    state.slideSectionActive.position = position
  },
  SET_SLIDE_CONTAINER_HOVER(state, { component_id }) {
    state.slideContainerHover.id = component_id
  },
  SET_SLIDE_CONTAINER_HOVER_POSITION(state, { position }) {
    state.slideContainerHover.position = position
  },
  SET_SLIDE_CONTAINER_ACTIVE(state, { component_id }) {
    state.slideContainerActive.id = component_id
  },
  SET_SLIDE_CONTAINER_ACTIVE_POSITION(state, { position }) {
    state.slideContainerActive.position = position
  },

  SET_CELL_HOVER(state, { component_id }) {
    state.cellHover.id = component_id
  },
  SET_CELL_HOVER_POSITION(state, { position }) {
    state.cellHover.position = position
  },
  SET_CELL_ACTIVE_POSITION(state, { position }) {
    state.cellActive.position = position
  },
  SET_CELL_ACTIVE(state, { component_id }) {
    state.cellActive.id = component_id
  },

  SET_GRID_HOVER_POSITION(state, { position }) {
    state.gridHover.position = position
  },
  SET_GRID_HOVER(state, { component_id }) {
    state.gridHover.id = component_id
  },

  SET_GRID_ACTIVE_POSITION(state, { position }) {
    state.gridActive.position = position;
  },

  SET_GRID_ACTIVE(state, { component_id }) {
    state.gridActive.id = component_id
  },
  SET_WIDGET_HOVER_POSITION(state, { position }) {
    state.widgetHover.position = position
  },
  SET_WIDGET_HOVER(state, { component_id }) {
    state.widgetHover.id = component_id
  },

  SET_WIDGET_ACTIVE_POSITION(state, { position }) {
    state.widgetActive.position = position;
  },
  SET_HEADER_WIDGET_POSITION(state, { position }) {
    state.widgetActive.position = position;
  },
  SET_WIDGET_ACTIVE(state, { component_id }) {
    state.widgetActive.id = component_id
  },
  SET_WIDGET_ACTIVE_THEME(state, { theme }) {
    state.widgetActive.theme = theme
  },
  SET_WIDGET_ACTIVE_TOOLBAR_ENABLE(state, { enable }) {
    state.widgetActive.toolbarEnable = enable
  },
  SET_WIDGET_ACTIVE_RESIZEDOT_ENABLE(state, { enable }) {
    state.widgetActive.resizeDotEnable = enable
  },
  SET_PARENT_WIDGET_ACTIVE(state, { component_id }) {
    state.parentWidgetActive.id = component_id
  },
  SET_PARENT_WIDGET_ACTIVE_POSITION(state, { position }) {
    state.parentWidgetActive.position = position
  },
  SET_SLIDE_ITEM_ACTIVE(state, { widgetId, index }) {
    state.slideItemActive.widgetId = widgetId;
    state.slideItemActive.index = index
  },
  SET_SLIDEBLOCK_HOVER(state, { component_id, index, parent_id }) {
    state.slideBlockHover.id = component_id
    state.slideBlockHover.index = index
    state.slideBlockHover.parent_id = parent_id
  },
  SET_SLIDEBLOCK_HOVER_POSITION(state, { position }) {
    state.slideBlockHover.position = position
  },
  SET_SLIDEBLOCK_ACTIVE_POSITION(state, { position }) {
    state.slideBlockActive.position = position
  },
  SET_SLIDEBLOCK_ACTIVE(state, { component_id, index, parent_id }) {
    state.slideBlockActive.id = component_id
    state.slideBlockActive.index = index
    state.slideBlockActive.parent_id = parent_id
  },
  SET_RESIZE_MARGIN_HOVER(state, { type, component_id, parent_id, direction, label_add_btn, is_last, other_id, height, is_first, is_show_add_btn}) {
    state.resizeMarginHover.id = component_id
    state.resizeMarginHover.type = type
    state.resizeMarginHover.parent_id = parent_id
    state.resizeMarginHover.direction = direction
    state.resizeMarginHover.label_add_btn = label_add_btn
    state.resizeMarginHover.is_last = is_last
    state.resizeMarginHover.other_id = other_id
    state.resizeMarginHover.height = height
    state.resizeMarginHover.is_first = is_first
    state.resizeMarginHover.is_show_add_btn = is_show_add_btn
  },
  SET_RESIZE_MARGIN_HOVER_POSITION(state, { position }) {
    state.resizeMarginHover.position = position
  },
  SET_ADD_BTN_ACTIVE(state, { type, component_id, parent_id, direction, label_add_btn }) {
    state.addBtnActive.id = component_id
    state.addBtnActive.type = type
    state.addBtnActive.parent_id = parent_id
    state.addBtnActive.direction = direction
    state.addBtnActive.label_add_btn = label_add_btn
  },
  SET_ADD_BTN_ACTIVE_POSITION(state, { position }) {
    state.addBtnActive.position = position
  },
  SET_DISABLE_DRAG_WIDGET_ID(state, { widgetId }) {
    state.disableDragWidgetId = widgetId;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};